import { HiFolderDownload } from "react-icons/hi";
import { translate } from "ui/i18n";

interface IProps {
  selectedSeances: number[];
}

export function FolderSelectionZone({ selectedSeances }: IProps) {
  return (
    <div className="w-full bg-darkGrey-700 px-2 py-4 shadow-lg md:px-12 md:px-6">
      <div className="flex items-center">
        <div className="flex w-full items-center justify-center gap-x-3 md:gap-x-6">
          <div className="flex items-center">
            <HiFolderDownload color="#fff" size={32} />
            <p className="ms-3 flex text-base font-normal text-white md:ms-6">
              {selectedSeances.length}{" "}
              {translate(
                selectedSeances.length > 1
                  ? "ns1:Folders.SeancesSelected"
                  : "ns1:Folders.SeanceSelected"
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
